// extracted by mini-css-extract-plugin
export default {"departments":"mG-z","departmentHeading":"nG-z","departmentSection":"oG-z","departmentName":"pG-z","departmentLink":"qG-z","expandIcon":"rG-z"};